import { breakpoints } from 'config/breakpoints';
import { gridCssResponsiveVariables } from '../grid';
import { ratiosCssResponsiveVariables } from '../ratios';
import { spacingCssResponsiveVariables } from '../spacing';
import { transitionsCssResponsiveVariables } from '../transitions';
import { zIndexCssResponsiveVariables } from '../z-index';
import { type Theme } from './index';

// All statics here must use the --orange-- prefix so they are picked up in core-web App/Styles
// and exposed on :root for the data-theme switch. Unprefixed vars would be ignored.
const statics = {
    // UI
    '--orange--ui-primary': 'var(--color-base-charcoal)',
    '--orange--ui-secondary': 'var(--color-base-off-white)',
    '--orange--ui-background': 'var(--color-base-brickwork-orange)',
    '--orange--overlay-overlay-background': 'var(--color-opacity-light-beige-90)',
    '--orange--stroke-default': 'var(--color-opacity-charcoal-15)',
    '--orange--stroke-hover': 'var(--color-base-off-white)',
    '--orange--stroke-active': 'var(--color-base-off-white)',
    '--orange--gradient-30': 'var(--color-opacity-orange-30)',
    '--orange--gradient-0': 'var(--color-opacity-orange-0)',
    '--orange--semantic-error': 'var(--color-semantic-red)',
    '--orange--semantic-warning': 'var(--color-semantic-yellow)',
    '--orange--semantic-success': 'var(--color-semantic-green)',
    '--orange--gradient-100': 'var(--color-base-brickwork-orange)',
    '--orange--opacity-primary-50': 'var(--color-opacity-charcoal-50)',
    '--orange--opacity-primary-30': 'var(--color-opacity-charcoal-30)',
    '--orange--opacity-primary-15': 'var(--color-opacity-charcoal-15)',
    '--orange--stroke-heavy': 'var(--color-opacity-charcoal-30)',
    '--orange--stroke-full': 'var(--color-base-charcoal)',
    '--orange--ui-secondary-aa': 'var(--color-base-off-white)',
    '--orange--ui-surface': 'var(--color-shade-medium-orange)',
    '--orange--ui-primary-aa': 'var(--color-base-charcoal)',

    // Button
    '--orange--button-primary-background': 'var(--color-base-off-white)',
    '--orange--button-secondary-background': 'var(--color-base-charcoal)',
    '--orange--button-primary-text': 'var(--color-base-charcoal)',
    '--orange--button-secondary-text': 'var(--color-base-off-white)',
    '--orange--button-tertiery-text': 'var(--color-base-charcoal)',
    '--orange--button-tertiery-stroke': 'var(--color-opacity-charcoal-15)',
    '--orange--button-primary-text-hover': 'var(--color-base-brickwork-orange)',
    '--orange--button-primary-text-active': 'var(--color-base-brickwork-orange)',
    '--orange--button-primary-text-disabled': 'var(--color-opacity-charcoal-50)',
    '--orange--button-primary-background-disabled': 'var(--color-base-off-white)',
    '--orange--button-secondary-text-hover': 'var(--color-base-brickwork-orange)',
    '--orange--button-secondary-text-active': 'var(--color-base-brickwork-orange)',
    '--orange--button-secondary-text-disabled': 'var(--color-opacity-off-white-50)',
    '--orange--button-secondary-background-disabled': 'var(--color-shade-light-charcoal)',
    '--orange--button-tertiery-text-hover': 'var(--color-base-off-white)',
    '--orange--button-tertiery-text-active': 'var(--color-base-off-white)',
    '--orange--button-tertiery-text-disabled': 'var(--color-opacity-charcoal-50)',
    '--orange--button-tertiery-stroke-hover': 'var(--color-opacity-off-white-15)',
    '--orange--button-tertiery-stroke-active': 'var(--color-opacity-off-white-15)',
    '--orange--button-tertiery-stroke-heavy': 'var(--color-opacity-charcoal-30)',
    '--orange--button-tertiery-text-focus-outline': '2px solid var(--orange--button-tertiery-text)',
};

const responsives = {} as Theme['responsives'];
breakpoints.forEach((breakpoint) => {
    responsives[breakpoint.label] = {
        ...ratiosCssResponsiveVariables[breakpoint.label],
        ...gridCssResponsiveVariables[breakpoint.label],
        ...transitionsCssResponsiveVariables[breakpoint.label],
        ...zIndexCssResponsiveVariables[breakpoint.label],
        ...spacingCssResponsiveVariables[breakpoint.label],

        ...responsives[breakpoint.label],
    };
});

const theme: Theme = {
    statics,
    responsives,
};

export default theme;
